export const teamMembers = [
  {
    id: 1,
    name: '林婉清',
    role: '创始人 & CEO',
    description: '心理学博士，国家二级心理咨询师，曾在知名情感咨询机构担任首席顾问十年。专注于亲密关系研究，致力于用科学与温暖帮助更多人找到长久的幸福。',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20in%20her%20forties%20professional%20portrait%20warm%20confident%20smile%20clean%20cream%20background%20editorial%20style%20simple%20white%20blazer%20natural%20lighting&width=400&height=400&seq=team-ceo&orientation=squarish',
  },
  {
    id: 2,
    name: '陈思远',
    role: '首席情感顾问',
    description: '应用心理学硕士，情感关系领域资深专家。累计辅导超过5000对伴侣，擅长运用认知行为疗法帮助伴侣改善沟通模式和情感连接。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20in%20his%20thirties%20warm%20approachable%20portrait%20clean%20cream%20background%20editorial%20style%20simple%20navy%20shirt%20natural%20light&width=400&height=400&seq=team-advisor&orientation=squarish',
  },
  {
    id: 3,
    name: '苏雨晴',
    role: '高级情感陪伴师',
    description: '社会学硕士，专注于长期关系维护与感情修复。她的咨询风格温柔而有力，善于帮助来访者在脆弱中找到力量，在迷茫中找到方向。',
    avatar: 'https://readdy.ai/api/search-image?query=Gentle%20Chinese%20woman%20in%20her%20early%20thirties%20kind%20thoughtful%20expression%20portrait%20clean%20cream%20background%20editorial%20style%20simple%20beige%20blouse%20warm%20lighting&width=400&height=400&seq=team-companion&orientation=squarish',
  },
  {
    id: 4,
    name: '周明远',
    role: '技术总监',
    description: '人工智能博士，前大厂算法工程师。负责久久爱伴侣匹配算法的研发与优化，致力于将前沿AI技术与心理学理论结合，打造最精准的情感匹配系统。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%20mid%20thirties%20intelligent%20friendly%20portrait%20clean%20cream%20background%20editorial%20style%20simple%20dark%20shirt%20warm%20natural%20light&width=400&height=400&seq=team-cto&orientation=squarish',
  },
];